export class GetUniqueManagerAccessPinResponseDto {
  // @ApiProperty({
  //   description: 'Manager Access Pin',
  //   maxLength: 6,
  //   minLength: 6,
  //   example: 456789,
  // })
  managerAccessPin: string;
}
